import ArrowDown from '@/assets/icons/arrow-down.svg?react';
import RouteConstants from '@/features/router/RouteConstants';
import { IconButton } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export const ReturnToLoginButton: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const onLoginButtonClicked = () => {
    history.push(RouteConstants.root);
  };

  return (
    <IconButton
      intent='link-grey'
      leadingIcon={<ArrowDown className='size-5 rotate-90 text-quaternary-400' />}
      text={t('ALL:returnToLogin')}
      onClick={onLoginButtonClicked}
    />
  );
};
